import { useIntl } from '@capsicum/common';

export const useNCWConfirmTransferAmountCard = () => {
	const { $t } = useIntl();

	return {
		intlTexts: {
			amount: $t('ncWallet.send.confirmation.amount')
		}
	};
};
